<template>
  <div
    class="modal fade"
    id="addToPavementModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    role="dialog"
    aria-labelledby="addToPavementModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-if="show">
        <div class="modal-header shadow-sm">
          <h6 class="modal-title font-weight-bold" id="addToPavementModalLabel">
            <p class="mb-1">Add Pavement Case</p>
          </h6>
        </div>
        <div class="modal-body">
          <div class="row mx-0 mb-3">
            <!-- <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small mb-1">
                    District<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="w-100 btn btn-sm btn-block bg-white dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3"
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownDistrictButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      v-if="
                        districts.find(
                          (district) => district.id == models.district
                        )
                      "
                    >
                      {{
                        districts.find(
                          (district) => district.id == models.district
                        ).name
                      }}
                    </span>
                    <span v-else class="text-muted"> -- Select district </span>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow-sm p-0"
                    aria-labelledby="dropdownDistrictButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                    <input
                      class="form-control form-control-sm"
                      placeholder="Search"
                      v-model="districtSearchModel"
                    />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button
                        v-for="district in computedDistricts"
                        :key="`select-district-${district.id}`"
                        class="border-bottom dropdown-item px-3 py-2"
                        :class="{
                          'bg-subtle': models.district == district.id,
                        }"
                        style="color: #495057"
                        @click="models.district = district.id"
                      >
                        {{ district.name }}
                        <i
                          class="fas fa-check text-primary ml-2 small"
                          v-if="models.district == district.id"
                        />
                      </button>
                      <div
                        class="dropdown-item py-2 small text-center text-muted font-italic px-3 py-2 fs-8"
                      >
                        <span v-if="computedDistricts.length > 0">
                          End of list
                        </span>
                        <span v-else>No district found</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small mb-1">
                    Road<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="w-100 btn btn-sm btn-block bg-white dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3"
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownRoadButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <!-- <span
                      v-if="
                        roads.find((road) => road.id == models.iraa_road_id)
                      "
                    >
                      ({{ roads.find((road) => road.id == models.iraa_road_id).attributes.owner }})
                      {{
                        roads.find((road) => road.id == models.iraa_road_id)
                          .attributes.name
                      }}
                    </span> -->
                    <span class="text-muted"> -- Select road </span>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow-sm p-0"
                    aria-labelledby="dropdownRoadButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                  
                      <input
                        class="form-control form-control-sm"
                        placeholder="Search"
                        type="search"
                        v-model="roadSearchModel"
                        @keyup.enter="searchRoad"
                      />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button
                        v-for="road in listRoads"
                        :key="road.id"
                        class="border-bottom dropdown-item d-flex justify-content-between align-items-center px-3 py-2"
                        :class="{
                          'bg-subtle': models.pavement_road == road.id,
                        }"
                        style="color: #495057"
                        @click="addRoad(road)"
                      >
                      ({{ road.attributes.owner }})
                        {{ road.attributes.name }}
                        <i
                          class="fas fa-check text-primary ml-2 small"
                          v-if="models.pavement_road == road.id"
                        />
                      </button>
                      <div
                        class="dropdown-item py-2 small text-center text-muted font-italic px-3 py-2 fs-8"
                      >
                        <span v-if="listRoads.length > 0">
                          End of list
                        </span>
                        <span v-else>No road found</span>
                      </div>
                    </div>
                  </div>
                  <div class="w-100 mt-2">
                    <div class="w-100 d-flex align-items-center justify-content-between border-bottom p-2" v-for="iraa_road of models.iraa_road" :key="iraa_road.id">
                      <p class="m-0">{{iraa_road.attributes.name}}</p>
                      <button class="btn btn-sm btn-danger" @click="() => { models.iraa_road = models.iraa_road.filter(road => road.id != iraa_road.id)}">Delete</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="serialNo">Serial Number</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="serialNo"
                  placeholder="Enter serial number"
                  v-model="models.serialNo"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="timestamp">Date</label>
                <button
                  class="btn btn-sm bg-white w-100 d-flex justify-content-between align-items-center"
                  @click="showDatetimeSelector = true"
                >
                  <span>
                    {{ formatDate(models.timestamp) || "Click to select date" }}
                  </span>
                  <i class="fas fa-calendar-alt" />
                </button>
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="caption">Type of defect</label>
                <textarea
                  rows="5"
                  class="form-control form-control-sm"
                  id="Caption"
                  placeholder="Enter type of defect"
                  v-model="models.caption"
                />
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="coordiante">Coordinate</label>
                <div class="row">
                  <div class="col px-2">
                    <input
                      type="text"
                      step="any"
                      min="0"
                      class="form-control form-control-sm"
                      id="lat"
                      placeholder="Enter latitude"
                      v-model="models.lat"
                    />
                  </div>
                  <div class="col px-2">
                    <input
                      type="text"
                      step="any"
                      min="0"
                      class="form-control form-control-sm"
                      id="lng"
                      placeholder="Enter longitude"
                      v-model="models.lng"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="caption">Ortho Before</label>
                <input
                  class="form-control form-control-sm"
                  id="ortho_after"
                  placeholder="Enter Ortho Before url"
                  v-model="models.ortho_before"
                />
              </div>
            </div>
          </div>

          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="caption">Ortho After</label>
                <input
                  class="form-control form-control-sm"
                  id="ortho_after"
                  placeholder="Enter Ortho After url"
                  v-model="models.ortho_after"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="saveChanges()"
            :disabled="isProcessing"
          >
            <div
              class="spinner-border spinner-border-sm text-light"
              v-if="isProcessing"
            ></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>

    <datetime-selector
      v-if="showDatetimeSelector"
      :date="models.timestamp"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import { Modal } from "bootstrap/dist/js/bootstrap.esm.min";
import DatetimeSelector from "@/components/DatetimeSelector";
import MediaViewer from "@/components/MediaViewer";
import Swal from "sweetalert2";

export default {
  name: "add-to-pavement-modal",
  props: ["show"],
  components: { MediaViewer, DatetimeSelector },
  data() {
    return {
      modal: null,
      showDatetimeSelector: false,
      isProcessing: false,
      districts: [],
      roads: [],
      districtSearchModel: null,
      roadSearchModel: null,
      listRoads: [],
      models: {
        serialNo: null,
        district: null,
        pavement_road: null,
        caption: null,
        timestamp: null,
        lat: null,
        lng: null,
        iraa_road: null,
        status: "Pending_Site_Visit",
        ortho_before: null,
        ortho_after: null,
      },
      emptyModels: {
        serialNo: null,
        district: null,
        pavement_road: null,
        caption: null,
        timestamp: null,
        lat: null,
        lng: null,
        iraa_road: null,
        status: "Pending_Site_Visit",
        ortho_before: null,
        ortho_after: null,
      },
    };
  },
  watch: {
    isProcessing: {
      handler() {
        this.Helper.toggleLoadingSpinner(this.isProcessing);
      },
      deep: true,
      immediate: true,
    },
    show: {
      async handler() {
        if (this.modal && this.show) {
          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          this.modal.show();

          // await this.getDistricts();
          await this.getIraaRoads()
        } else if (this.modal) {
          this.modal.hide();

          this.districts = [];
          this.roadSearchModel = null
          this.roads = [];
        }
      },
      immediate: true,
    },
    "models.district": {
      async handler() {
        if (this.models.district) {
          this.models.pavement_road = null;

          await this.getRoads();
        }
      },
      immediate: true,
      deep: true,
    },
    roadSearchModel: {
      async handler() {
        if (!this.roadSearchModel && this.roads.length) {
          this.listRoads = JSON.parse(JSON.stringify(this.roads))
        }
      },
      immediate: true,
      deep: true,
    }
  },
  computed: {
    computedDistricts() {
      let list = JSON.parse(JSON.stringify(this.districts));

      if (this.districtSearchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.districtSearchModel.toLowerCase())
        );
      }

      return list;
    },
    // computedRoads() {
    //   let list = JSON.parse(JSON.stringify(this.roads));

    //   if (this.roadSearchModel) {
    //     list = list.filter((l) =>
    //       l.attributes.name.toLowerCase().includes(this.roadSearchModel.toLowerCase())
    //     );
    //   }

    //   return list;
    // },
  },
  methods: {
    searchRoad(){
      if(this.roadSearchModel){
        return this.API.getFromIraa(`roads?filters[isTurapanMega]=true&filters[name][$containsi]=${this.roadSearchModel}&sort[0]=owner&pagination[limit]=1000`)
        .then((retVal) => {
          this.listRoads = retVal.data.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
      }
    },
    addRoad(road){
      if(this.models.iraa_road){
        this.models.iraa_road.push(road)
      } else {
        this.models.iraa_road = [road]
      }
    },
    async getIraaRoads() {
      this.isProcessing = true;

      return this.API.getFromIraa(`roads?filters[isTurapanMega]=true&sort[0]=owner&pagination[limit]=1000`)
        .then((retVal) => {
          this.roads = retVal.data.data;
          this.listRoads = JSON.parse(JSON.stringify(this.roads))
          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    dateSelected(e) {
      if (e) {
        this.models.timestamp = e;
      }

      this.showDatetimeSelector = false;
    },
    async getDistricts() {
      this.isProcessing = true;

      return this.API.get("districts?name_nin=MPKL&name_nin=Test District")
        .then((retVal) => {
          this.districts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    async getRoads() {
      this.isProcessing = true;

      return this.API.get(`pavement-roads?district=${this.models.district}`)
        .then((retVal) => {
          this.roads = retVal.data;
          
          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    formatDate(timestamp) {
      return this.Helper.formatDate(timestamp);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
    async saveChanges() {
      this.isProcessing = true;
      // this.models.iraa_road_id = this.roads.find((road) => road.id == this.models.pavement_road).id.toString()
      // this.models.iraa_road_name = this.roads.find((road) => road.id == this.models.pavement_road).attributes.name
      delete this.models.pavement_road

      await this.API.post("pavement-cases", this.models);

      this.isProcessing = false;

      Swal.fire("Pavement Case Created", "", "success").then(() => {
        this.closeModal(true);
      });
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("addToPavementModal"));
  },
};
</script>